import * as React from "react";
import { Heading } from "@grandvisionhq/elements";
/* empty css               */
import { useBreakpoint, BreakpointName } from "../../MediaQuery/MediaQuery/MediaQueryContext.js";
const Column = (_) => null;
Column.displayName = "Column";
const Footer = (_) => null;
Footer.displayName = "Footer";
const defaultRowKeyFormatter = (rowIndex) => rowIndex.toString();
const Table = ({
  caption,
  children,
  numberOfRows,
  "aria-level": ariaLevel,
  rowKeyFormatter = defaultRowKeyFormatter
}) => {
  const currentBreakpoint = useBreakpoint();
  if (!children) {
    console.warn(`<DataTable /> component needs a column definition to work`);
    return null;
  }
  const isMobile = currentBreakpoint === BreakpointName.TABLET_PORTRAIT || currentBreakpoint === BreakpointName.PHONE;
  const { columns, footer } = React.Children.toArray(children).reduce(
    (result, child) => {
      if (!React.isValidElement(child)) {
        return result;
      }
      switch (child.type) {
        /**
         * Parse props from columns, set renderer to child function
         */
        case Column:
          return {
            columns: [
              ...result.columns,
              {
                renderer: child.props.children,
                header: child.props.header,
                key: child.props.id || child.props.header
              }
            ],
            footer: result.footer
          };
        /**
         * Set footer to children of <Footer /> element
         */
        case Footer:
          return {
            ...result,
            footer: child.props.children
          };
        default:
          return result;
      }
    },
    { columns: [], footer: null }
  );
  return /* @__PURE__ */ React.createElement("div", { className: "data-table" }, /* @__PURE__ */ React.createElement(Heading, { variant: "smallest", "aria-level": ariaLevel }, caption), /* @__PURE__ */ React.createElement("div", { className: "data-table__wrapper" }, isMobile ? /* @__PURE__ */ React.createElement("ul", { "aria-label": caption }, Array.from({ length: numberOfRows }).map((_, index) => /* @__PURE__ */ React.createElement("li", { key: rowKeyFormatter(index) }, /* @__PURE__ */ React.createElement("dl", null, columns.map((c) => /* @__PURE__ */ React.createElement(React.Fragment, { key: c.key }, /* @__PURE__ */ React.createElement("dt", null, c.header), /* @__PURE__ */ React.createElement("dd", null, c.renderer(index)))))))) : /* @__PURE__ */ React.createElement("table", { "aria-label": caption }, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", null, columns.map((c) => /* @__PURE__ */ React.createElement("th", { scope: "col", key: c.key }, c.header)))), /* @__PURE__ */ React.createElement("tbody", null, Array.from({ length: numberOfRows }).map((_, index) => /* @__PURE__ */ React.createElement("tr", { key: rowKeyFormatter(index) }, columns.map((c) => /* @__PURE__ */ React.createElement("td", { key: c.key }, c.renderer(index))))))), footer && /* @__PURE__ */ React.createElement("div", { className: "data-table__footer" }, footer)));
};
Table.Col = Column;
Table.Footer = Footer;
export {
  Column,
  Footer,
  Table,
  Table as default
};
//# sourceMappingURL=DataTable.js.map
